import React from "react";
import { Wifi, Coffee, Clock, Sofa, ParkingCircle } from "lucide-react";
import Reveal from "./Reveal";

const AMENITIES = [
  {
    icon: Clock,
    title: "45 a 60 min",
    desc: "Mudança de pneus expresso enquanto descansa.",
    accent: true,
  },
  {
    icon: Wifi,
    title: "Wi-Fi gratuito",
    desc: "Continue o trabalho ou relaxe online.",
  },
  {
    icon: Coffee,
    title: "Café & água",
    desc: "Por nossa conta, durante a sua espera.",
  },
  {
    icon: Sofa,
    title: "Sala de espera",
    desc: "Confortável, com vista para a oficina — observe tudo enquanto descansa.",
  },
  {
    icon: ParkingCircle,
    title: "Estacionamento",
    desc: "Próprio à porta da oficina, sem complicações.",
  },
];

export const WaitingExperience = () => (
  <section
    data-testid="waiting-section"
    className="relative py-14 md:py-16 bg-[#0B1D44] overflow-hidden"
  >
    <div aria-hidden="true" className="gradient-divider absolute top-0 inset-x-0" />
    {/* Decorative diagonal grid */}
    <div
      aria-hidden="true"
      className="absolute inset-0 opacity-[0.04] pointer-events-none"
      style={{
        backgroundImage:
          "linear-gradient(115deg, transparent 0 39px, #FFFFFF 39px 40px), linear-gradient(25deg, transparent 0 39px, #FFFFFF 39px 40px)",
      }}
    />

    <div className="relative w-full px-6 md:px-12 lg:px-20">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-5 mb-8">
          <div className="max-w-2xl">
            <span className="section-label flex items-center gap-2">
              <Coffee className="w-4 h-4" />
              // Enquanto espera
            </span>
            <h2 className="font-display font-bold text-white text-3xl md:text-4xl lg:text-5xl uppercase tracking-tight mt-3 leading-[0.98]">
              Mudamos os pneus.
              <br />
              <span className="text-[#FF5A00]">Você relaxa.</span>
            </h2>
          </div>
          <p className="text-[#A1A1AA] font-body text-sm md:text-base max-w-sm">
            A sua espera não é tempo perdido. Temos tudo pensado para que se
            sinta em casa enquanto o seu carro fica como novo.
          </p>
        </div>

        {/* Amenities grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {AMENITIES.map((a, i) => {
            const Icon = a.icon;
            return (
              <Reveal
                key={a.title}
                delay={i * 90}
                className={`group flex flex-col p-4 rounded-2xl border transition-colors ${
                  a.accent
                    ? "bg-[#FF5A00] border-[#FF5A00] text-black col-span-2 md:col-span-1 lg:col-span-1"
                    : "bg-[#0E2452]/60 border-[#2F568F] text-white hover:border-[#FF5A00]"
                }`}
              >
                <div
                  data-testid={`amenity-${a.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                >
                  <div
                    className={`w-10 h-10 rounded-xl flex items-center justify-center mb-3 border transition-colors ${
                      a.accent
                        ? "border-black/30 bg-black/10"
                        : "border-[#2F568F] group-hover:border-[#FF5A00] group-hover:bg-[#FF5A00]/10"
                    }`}
                  >
                    <Icon
                      className={`w-5 h-5 ${a.accent ? "text-black" : "text-[#FF5A00]"}`}
                      strokeWidth={2}
                    />
                  </div>
                  <div
                    className={`font-display font-bold uppercase tracking-tight text-base md:text-lg leading-tight mb-1 ${
                      a.accent ? "text-black" : "text-white"
                    }`}
                  >
                    {a.title}
                  </div>
                  <p
                    className={`font-body text-xs md:text-sm leading-snug ${
                      a.accent ? "text-black/80" : "text-[#A1A1AA]"
                    }`}
                  >
                    {a.desc}
                  </p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </div>

    <style>{`
      @keyframes amenityIn {
        from { opacity: 0; transform: translateY(12px); }
        to   { opacity: 1; transform: translateY(0); }
      }
    `}</style>
  </section>
);

export default WaitingExperience;
